import NavigableValidation from "./navigableValidation";
import ProcessFlow from '~/models/processFlows/processFlow'

export default class ProcessFlowBuilderValidation extends NavigableValidation<ProcessFlow> {
  // TODO: When ProcessFlow need front end validations, start by uncommenting this section
  validators = [
  //   new EmbeddedCollectionValidator({
  //     validatorKey: "variables",
  //     section: ValidationModalSection.ProcessFlowVariable,
  //
  //   }, this.model),
  //   new EmbeddedCollectionValidator({
  //     validatorKey: "steps",
  //     section: ValidationModalSection.ProcessFlowVariable,
  //   }, this.model),
  ]
}